import { render, staticRenderFns } from "./PlanillaDetails.vue?vue&type=template&id=d6835408"
import script from "./PlanillaDetails.vue?vue&type=script&lang=js"
export * from "./PlanillaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports